'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = require('./types');

/* eslint-disable consistent-return */
var navigate = function navigate(history, action) {
  switch (action.type) {
    case _types.PUSH:
      history.push(action.payload);
      break;
    case _types.REPLACE:
      history.replace(action.payload);
      break;
    case _types.GO:
      history.go(action.payload);
      break;
    case _types.GO_BACK:
      history.goBack();
      break;
    case _types.GO_FORWARD:
      history.goForward();
      break;
    default:
      break;
  }
};

exports.default = function (_ref) {
  var history = _ref.history;
  return function () {
    return function (next) {
      return function (action) {
        if ((0, _types.isNavigationAction)(action)) {
          // Synchronously dispatch the original action so that the
          // reducer can add it to its location queue
          var originalDispatch = next(action);
          navigate(history, action);
          return originalDispatch;
        }

        return next(action);
      };
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-little-router/lib/middleware.js
// module id = 520
// module chunks = 0